










































































































































import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import moment from "moment";
import DatePicker from "@/components/ui/DatePicker.vue";
import FormValidator from "@/mixins/FormValidator";
import { ChangePlanModule } from "@/store/change-plan.module";
import { translate } from "@/utils";
import { Plan } from "~/plan";
import { PlansDto } from "../../../../../lib/plans.dto";
import TableCellTooltip from "@/components/ui/TableCellTooltip.vue";

@Component({
  components: { MonthPicker, DatePicker, TableCellTooltip },
})
export default class ChangePlanView extends Mixins(
  ContractIdValidatorMixin,
  FormValidator,
) {
  isComponentMounted: boolean = false;
  current = moment().format("YYYY-MM");
  formRef = "form";

  async newPlan() {
    ChangePlanModule.setCurrentPlan(null as any);
    this.$router.push("change-plan-new");
  }

  async openPlan(item: Plan) {
    ChangePlanModule.setCurrentPlan(item);
    this.$router.push({
      name: "change-plan-edit",
      params: {
        idplan: item.record_id.toString(),
      },
    });
  }

  get from() {
    return ChangePlanModule.from;
  }
  set from(val) {
    ChangePlanModule.setFrom(val);
    this.onFiltersChange();
  }
  get to() {
    return ChangePlanModule.to;
  }
  set to(val) {
    ChangePlanModule.setTo(val);
    this.onFiltersChange();
  }
  get planStatuseFilter() {
    return ChangePlanModule.planStatuseFilter;
  }
  set planStatuseFilter(val) {
    ChangePlanModule.setPlanStatuseFilter(val);
    this.onFiltersChange();
  }
  get planListLength() {
    return ChangePlanModule.planListLength;
  }
  get planLoading() {
    return ChangePlanModule.planLoading;
  }
  get planListPagination() {
    return ChangePlanModule.planListPagination;
  }
  set planListPagination(val) {
    ChangePlanModule.setAppealListPagination(val);
    this.onFiltersChange();
  }
  get getPlanList(): Plan[] {
    return translate(ChangePlanModule.planList);
  }
  get headers() {
    return [
      {
        text: this.$t("actions.change-plan.number"),
        value: "number",
        sortable: false,
      },
      {
        text: this.$t("actions.change-plan.date_create"),
        value: "action_date",
        sortable: false,
      },
      {
        text: this.$t("actions.change-plan.contract"),
        value: "contract_number",
        sortable: false,
      },
      {
        text: this.$t("actions.change-plan.status"),
        value: "status_name",
        sortable: false,
      },
      {
        text: "",
        value: "",
        sortable: false,
      },
    ];
  }

  async mounted() {
    setTimeout(() => {
      this.isComponentMounted = true;
      ChangePlanModule.getStatuses();
      this.loadTablePlans();
    }, 500);
  }

  async onFiltersChange() {
    if (!this.isComponentMounted) return;
    await this.loadTablePlans();
  }

  get planStatuses() {
    return translate(ChangePlanModule.changePlanStatuses);
  }

  async created() {
    this.to = moment().format("YYYY-MM");
    this.from = moment()
      .subtract(5, "months")
      .format("YYYY-MM");
    await this.loadTablePlans();
  }

  async loadTablePlans() {
    ChangePlanModule.setPlanLoading(true);
    const req: PlansDto = new PlansDto();
    req.iContractRid = Number(this.$route.params.id);
    req.StartDate = moment(String(this.from)).format("YYYY-MM-DD");
    req.EndDate = moment(String(this.to)).format("YYYY-MM-DD");
    req.Status = this.planStatuseFilter;
    (req.iLimit = this.planListPagination.itemsPerPage),
      (req.iOffset =
        this.planListPagination.itemsPerPage *
        (this.planListPagination.page - 1));
    ChangePlanModule.getPlans(req);
  }

  validateDates() {
    if (!this.from) return true;
    if (moment(this.from).isAfter(this.to))
      return this.$t("reportsInfo.initial_period_later_than_final");
    else return true;
  }
}
